import React from 'react';
import '../../css/RefoundPolicy.css'; // Optional: Link to your CSS file

function RefundPolicy() {
  return (
    <div className="policy-container">
      <h1>Refund & Returns Policy</h1>
      
      <p>
        Our refund and returns policy lasts <strong>03 days</strong>. If 03 days have passed since your purchase, 
        we can’t offer you a full refund or exchange.
      </p>

      <p>
        To be eligible for a return, your item must be unused and in the same condition that you received it. 
        It must also be in the original packaging.
      </p>

      <p>
        Several types of goods are exempt from being returned. Goods such as <strong>Sex Toys, Dolls, Lingerie, or BDSM accessories</strong> 
        cannot be returned due to reasons of personal hygiene.
      </p>

      <h2>Additional non-returnable items:</h2>
      <ul>
        <li>Gift cards</li>
        <li>Some health and personal care items</li>
      </ul>

      <p>
        To complete your return, we require a receipt or proof of purchase.
      </p>

      <h2>Partial Refunds</h2>
      <ul>
        <li>Any item not in its original condition, is damaged, or missing parts for reasons not due to our error.</li>
        <li>Any item that is returned more than 03 days after delivery.</li>
      </ul>

      <h2>Refunds</h2>
      <p>
        Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. 
        We will also notify you of the approval or rejection of your refund.
      </p>
      <p>
        If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card 
        or original method of payment, within a certain amount of days.
      </p>

      <h2>Late or Missing Refunds</h2>
      <p>
        If you haven’t received a refund after 30 days, contact us.
      </p>

      <h2>Sale Items</h2>
      <p>
        Only regular priced items may be refunded. Sale items cannot be refunded.
      </p>

      <h2>Exchanges</h2>
      <p>
        We only replace items if they are defective or damaged. If you need to exchange it for the same item, 
        send us an email at <a href="mailto:prettylovecolombo@gmail.com">prettylovecolombo@gmail.com</a>. 
        There will be no more exchanges or refunds for the same product after exchange items have been delivered.
      </p>

      <h2>Gifts</h2>
      <p>
        If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. 
        Once the returned item is received, a gift certificate will be mailed to you.
      </p>
      <p>
        If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, 
        we will send a refund to the gift giver and they will find out about your return.
      </p>

      <h2>Shipping Returns</h2>
      <p>
        You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. 
        If you receive a refund, the cost of return shipping will be deducted from your refund.
      </p>
      <p>
        Depending on where you live, the time it may take for your exchanged product to reach you may vary.
      </p>
      <p>
        If you are returning more expensive items, you may consider using a trackable shipping service or purchasing shipping insurance. 
        We don’t guarantee that we will receive your returned item.
      </p>

      <h2>Need Help?</h2>
      <p>
        Contact us at <strong>prettylovecolombo@gmail.com</strong> for questions related to refunds and returns.
      </p>
    </div>
  );
}

export default RefundPolicy;